const registry = new Map<string, File>();

export const registerFile = (jobId: string, file: File): void => {
  registry.set(jobId, file);
};

export const getFile = (jobId: string): File | undefined => registry.get(jobId);

export const dropFile = (jobId: string): void => {
  registry.delete(jobId);
};

export const clearRegistry = (): void => {
  registry.clear();
};
